export const CUSTOM_RECT_TYPE = "CustomRect";
